export default __webpack_public_path__ + "static/media/room-2Bed-double-F2.ccd7faa6.jpg";